import {
  Submission, SurveySettings, UserType,
} from '../../types';
import { apiError } from '../../utils/errors';
import { fetchWithRetry } from '../../utils/fetch-with-retry';

interface SubmissionData {
  submission: Submission;
  settings: SurveySettings;
}

export const getSubmissionData = async (
  urlSlug: string,
  publicId: string,
  userType: UserType,
  token?: string,
): Promise<SubmissionData> => {
  const baseUrl = `${process.env.REACT_APP_API_URL}/submissions/${urlSlug}/${publicId}?userType=${userType}`;
  const url = token ? `${baseUrl}&token=${token}` : baseUrl;
  const response = await fetchWithRetry(url, { credentials: 'include' });
  const responseJson = await response.json();

  if (!response.ok) {
    throw apiError(response.status, responseJson?.message || 'Failed to fetch application submission', responseJson?.code);
  }

  const { settings, submission } = responseJson.data;

  return {
    submission,
    settings,
  };
};
